import { getContextualRequest, normalizeUPApiError } from '../../../../modules/utils/index.js';
export async function fetchProductByRatePlanV2(client, { ratePlanCode }) {
    try {
        const req = await getContextualRequest(client);
        const res = await req.get(`${client.context.api.host}/subscriptions/products/rateplan/${ratePlanCode}`);
        return res.body;
    }
    catch (error) {
        throw normalizeUPApiError(error);
    }
}
